import { ClickObserver, Plugin } from 'ckeditor5';
/**
 * Placeholder authoring entry point.
 *
 * Clicking a chip resolves which occurrence was hit and hands it to `placeholders.onEditRequest`
 */
export class PlaceholderInteraction extends Plugin {
    static get pluginName() {
        return 'PlaceholderInteraction';
    }
    init() {
        const { editor } = this;
        if (editor.config.get('placeholders.readonly')) {
            return;
        }
        editor.editing.view.addObserver(ClickObserver);
        this.listenTo(editor.editing.view.document, 'click', (evt, data) => {
            const onEditRequest = editor.config.get('placeholders.onEditRequest');
            if (!onEditRequest) {
                return;
            }
            const domTarget = data.domEvent.target;
            const chip = domTarget.closest('.placeholder');
            if (!chip) {
                return;
            }
            const instanceId = this.resolveInstanceId(chip);
            if (!instanceId) {
                return;
            }
            const request = {
                instanceId,
                ref: chip.getAttribute('data-placeholder') || '',
                anchor: chip,
                isNew: false,
            };
            onEditRequest(request);
            evt.stop();
        }, { priority: 'high' });
    }
    /**
     * Maps the clicked DOM chip back to its model element's `instanceId`. The id never reaches the
     * HTML, so it is read off the model via the view mapping rather than from an attribute.
     */
    resolveInstanceId(chip) {
        const { editor } = this;
        const viewElement = editor.editing.view.domConverter.mapDomToView(chip);
        if (!viewElement || viewElement.is('documentFragment')) {
            return null;
        }
        const modelElement = editor.editing.mapper.toModelElement(viewElement);
        if (!modelElement || !modelElement.is('element', 'placeholder')) {
            return null;
        }
        return modelElement.getAttribute('instanceId') || null;
    }
}
